var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3898 17.1667C29.2232 17.1667 30.7093 15.6743 30.7093 13.8333C30.7093 11.9924 29.2232 10.5 27.3898 10.5C25.5565 10.5 24.0703 11.9924 24.0703 13.8333C24.0703 15.6743 25.5565 17.1667 27.3898 17.1667Z",
    stroke: "#535353",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15332 21.3335L7.06053 18.7792C8.57301 17.4504 10.8526 17.5265 12.2736 18.9535L19.3935 26.1031C20.5341 27.2486 22.3296 27.4047 23.6495 26.4732L24.1444 26.1241C26.0435 24.7837 28.6129 24.939 30.3384 26.4984L35.6886 31.3335",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2569 13.8333C37.2569 21.6899 37.3484 32.2851 34.9177 34.7258C32.4871 37.1666 28.5749 37.1666 20.7509 37.1666C12.9267 37.1666 9.01462 37.1666 6.58398 34.7258C4.15332 32.2851 4.15332 28.3566 4.15332 20.4999C4.15332 12.6432 4.15332 8.7148 6.58398 6.27404C9.01462 3.83325 12.9267 3.83325 20.7509 3.83325C28.5749 3.83325 32.4871 3.83325 34.9177 6.27404C36.534 7.89694 37.0755 10.1775 37.2569 13.8333Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/AddPhoto.e2e661129583042a752bbb06b3db56d8.svg";
export { ForwardRef as ReactComponent };